<template>
  <v-container fluid>
    <v-row>
      <v-col cols="auto">
        <v-navigation-drawer floating permanent width="220">
          <v-list  nav>
            <template v-for="(item) in items">
              <v-list-item
                v-if="!item.permission || hasPermission(item.permission)"
                :key="item.title"
                :to="item.route"
                link
                :disabled="item.disabled && item.disabled()"
              >
                <v-list-item-icon>
                  <v-icon small>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-navigation-drawer>
      </v-col>
      <v-col>
        <v-container fluid>
          <router-view /> 
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { hasPermission } from "../utils/permission";
export default {
  name: "Settings",
  methods: {
    hasPermission
  },
  computed: {
  },
  props: {},
  created() {},
  data() {
    return {
      items: [
        { title: "Profile", icon: "fa-user", route: "/settings" },
        {
          title: "Compliance",
          icon: "fa-toolbox",
          route: "/compliance",
          permission: "CAN_ADMIN_ACCOUNT"
        },
        {
          title: "Users",
          icon: "fa-users-cog",
          route: "/users",
          permission: "CAN_ADMIN_USER"
        },
        {
          title: "Account",
          icon: "fa-cogs",
          route: "/account",
          permission: "CAN_ADMIN_ACCOUNT"
        },
        // {
        //   title: "Invoices",
        //   icon: "fa-money-bill",
        //   route: "/invoices",
        //   permission: "CAN_ADMIN_INVOICES"
        // }
      ],
      right: null
    };
  }
};
</script>

<style>
</style>